var nurseslounge_degree_information = {
    init:function($params, cback){
        $params = $.extend({}, $params, {action:'info',tab:'degree_init'});
        nurseslounge_degree_information.information_degree_get($params, function($data){
            nurseslounge_degree_information.information_know_more($params, $data);
            nurseslounge_degree_information.information_rating($params, $data);
            nurseslounge_degree_information.information_request_edit($params, $data);
            try{
                google.maps.event.addListener(window, "load", nurseslounge_degree_information.information_location_map($data));
            }catch (e) {

            }
            if(cback != undefined){
                cback($data);
            }
        });
        nurseslounge_degree_information.information_meet_our_recruiters(function($config){
            nurseslounge_lounge_overview.information_meet_our_recruiters_engine($config);
        });
        nurseslounge_degree_information.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
    },
    information_degree_get:function($params, cback){
        $.ajax({
            url: "/degree/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-degree-information-edit-modal").modal('hide');
                    $("#nurseslounge-degree-request-info-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    information_know_more:function($params, $data){
        var $key = $data && $data.data && $data.data.key;
        var $isEmail = $data && $data.data && $data.data.degree && $data.data.degree.contact_is_email ? $data.data.degree.contact_is_email : false;
        var $contactEmailUrl = $data && $data.data && $data.data.degree && $data.data.degree.email ? $data.data.degree.email : false;
        var $title = $data && $data.data && $data.data.degree && $data.data.degree.title ? $data.data.degree.title : null;
        var $loungeLink = $data && $data.data && $data.data.degree && $data.data.degree.lounge && $data.data.degree.lounge.link ? $data.data.degree.lounge.link : null;
        var $degreeInformation = $("#nurseslounge-degree-information");
        var $degreeInformationRight = $degreeInformation.find('.nurseslounge-degree-information-right:first');
        var $whyWorkHere = $degreeInformationRight.find(".know-more .option[data-action='why-study-here']");
        var $requestInfo = $degreeInformationRight.find(".know-more .option[data-action='request-info']");
        var $applyOnWebsite = $degreeInformationRight.find(".know-more .option[data-action='apply-on-website']");
        var $degreeInformationLeft = $degreeInformation.find(".nurseslounge-degree-information-left:first");
        var $detail = $degreeInformationLeft.find(".detail");
        var $body = 'I saw your degree on Nurses Lounge and would like to apply.';
        var $subject = 'Application for '+$title+' - via Nurses Lounge';
        $whyWorkHere.unbind().click(function(){
            router.navigate($loungeLink,true);
        });
        $requestInfo.unbind().click(function(){
            nurseslounge_degree_information.information_request_info_events($params, $data);
        });
        $applyOnWebsite.unbind().click(function(){
            nurseslounge_degree_information.information_apply_set('apply', $params,function($data){
                var $statistics = $degreeInformationRight.find('.statistics:first');
                libs.refreshBoxFrom($statistics, $params, function(){
                    if($isEmail){
                        window.open('mailto:'+$contactEmailUrl+'?body='+$body+'&subject='+$subject, '_blank');
                    }else{
                        window.open($contactEmailUrl, '_blank');
                    }
                });
            });
        });
        $detail.unbind().click(function(){
            nurseslounge_degree_information.information_request_info_events($params, $data);
        });
    },
    information_apply_set:function($action, $params, cback){
        $.ajax({
            url: "/degree/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$.extend({}, $params, {action:$action}),
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-degree-information-edit-modal").modal('hide');
                    $("#nurseslounge-degree-request-info-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    information_rating:function($params, $data){
        var $typeId = $data.data.degree.lounge.lounge_type_id ? $data.data.degree.lounge.lounge_type_id : 0;
        var $loungeKey = $data.data.degree.lounge.key ? $data.data.degree.lounge.key : null;
        var $loungeData = $data.data.degree.lounge ? $data.data.degree.lounge : [];
        var $degreeInformation = $("#nurseslounge-degree-information");
        var $reviewModal = $("#nurseslounge-degree-information-review-modal");
        var $degreeInformationRight = $degreeInformation.find('.nurseslounge-degree-information-right:first');
        var $ratingFirst = $degreeInformationRight.find('.rating-stars:first');
        var $ratingCount = $degreeInformationRight.find('.rating-count:first');
        var $addReviewFirst = $degreeInformationRight.find('.add-review:first');
        var $deleteReviewFirst = $degreeInformationRight.find('.delete-review:first');
        $params = $.extend({}, $params, {key:$loungeKey}, {data:{lounge:$loungeData}});
        $ratingFirst.unbind().click(function(){
            nurseslounge_degree_information.information_review($params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_degree_information.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $ratingCount.unbind().click(function(){
            nurseslounge_degree_information.information_review($params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_degree_information.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $addReviewFirst.unbind().click(function(){
            nurseslounge_degree_information.information_review($params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_degree_information.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $deleteReviewFirst.unbind().click(function(){
            if(confirm('Are you sure you want to delete your review?')){
                nurseslounge_degree_information.information_remove_review($params, function(){
                    libs.refreshBoxFrom('.review-box', $params, function(){
                        nurseslounge_degree_information.init($params);
                        $reviewModal.modal('hide');
                    });
                });
            }
        });
    },
    information_location_map:function($data){
        var $location = $data && $data.data && $data.data.degree && $data.data.degree.lounge && $data.data.degree.lounge.location ? $data.data.degree.lounge.location : null;
        if($location && $location.address_latitude && $location.address_longitude && $location.address_is_unmappable == 0){
            var $position = new google.maps.LatLng(parseFloat($location.address_latitude), parseFloat($location.address_longitude));
            var $iconUrl =  './../../../../bimg/NursesLounge/active.png';
            var $map = new google.maps.Map(document.getElementById('nurseslounge-degree-information-right-map'), {
                center:$position,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoom: 15
            });
            $map.setTilt(0);
            var $marker = new google.maps.Marker({
                position:$position,
                map: $map,
                animation: google.maps.Animation.DROP,
                icon: {url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))},
            });
        }
    },
    information_request_info_events:function($params, $data){
        var $loungeLink = $data && $data.data && $data.data.degree && $data.data.degree.lounge && $data.data.degree.lounge.link ? $data.data.degree.lounge.link : null;
        var $modal = $("#nurseslounge-degree-request-info-modal");
        var $container = $modal.find(".request-info-modal-container");
        nurseslounge_degree_information.information_request_info_request($params, function($chtml){
            $container.html('').html($chtml).promise().done(function(){
                $modal.find("form").find("input[name='userPhoneNumber']").mask('+(00) 000-000-0000');
                nurseslounge_degree_information.information_request_info_validate(function($form){
                    $params = $.extend({}, $params, libs.getObjForm($form));
                    nurseslounge_degree_information.information_apply_set('info', $params, function(){
                        var $degreeInformation = $("#nurseslounge-degree-information");
                        var $degreeInformationRight = $degreeInformation.find('.nurseslounge-degree-information-right:first');
                        var $statistics = $degreeInformationRight.find('.statistics:first');
                        libs.refreshBoxFrom($statistics, $params, function(){
                            $modal.modal('hide');
                        });
                    });
                });
                /*
                var $reviewProfileLink = $modal.find(".review-profile-link");
                $reviewProfileLink.unbind().click(function(){
                    router.navigate($loungeLink,true);
                    $modal.modal('hide');
                });
                 */
                $modal.modal('show');
            });
        });
    },
    information_request_info_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/degree/requestInfoView/get',
            data: $params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-degree-information-edit-modal").modal('hide');
                    $("#nurseslounge-degree-request-info-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    information_request_info_validate:function(cback){
        var $validator = $("#nurseslounge-degree-request-info-modal form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                userName: {
                    required: true,
                    minlength: 2,
                    maxlength: 600
                },
                userEmail: {
                    required: true,
                    email:true,
                    minlength: 2,
                    maxlength: 191
                },
                userPhoneNumber: {
                    required: false,
                    minlength: 2,
                    maxlength: 18
                },
                userZipCode: {
                    required: false,
                    minlength: 2,
                    maxlength: 191
                }
            },
            messages: {
                userName: {
                    required: "The user name is required",
                    minlength: "The user name must have at least 2 characters",
                    maxlength: "The user name cannot exceed 600 characters"
                },
                userEmail: {
                    required: "The user email is required",
                    email:"The user email is invalid",
                    minlength: "The user email must have at least 2 characters",
                    maxlength: "The user email cannot exceed 191 characters"
                },
                userPhoneNumber: {
                    required: "The user phone is not required",
                    minlength: "The user phone must have at least 2 characters",
                    maxlength: "The user phone cannot exceed 18 characters"
                },
                userZipCode: {
                    required: "The user zip code is not required",
                    minlength: "The user zip code must have at least 2 characters",
                    maxlength: "The user zip code cannot exceed 191 characters"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },

    information_request_info_qr:function($params, $loungeLink){
        var $qr = $("#nurseslounge-degree-request-info-qr");
        var $form = $qr.find("form");
        $form.find("input[name='userPhoneNumber']").mask('+(00) 000-000-0000');
        nurseslounge_degree_information.information_request_info_qr_validate(function($form){
            nurseslounge_degree_information.information_request_info_qr_set($params, libs.getObjForm($form), function($data){
                window.open($data.data.link, '_self');
            });
        });
        /*
        var $reviewProfileLink = $qr.find(".review-profile-link");
        $reviewProfileLink.unbind().click(function(){
            window.open($loungeLink, '_self');
        });
         */
    },
    information_request_info_qr_validate:function(cback){
        var $validator = $("#nurseslounge-degree-request-info-qr form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                userName: {
                    required: true,
                    minlength: 2,
                    maxlength: 600
                },
                userEmail: {
                    required: true,
                    email:true,
                    minlength: 2,
                    maxlength: 191
                },
                userPhoneNumber: {
                    required: false,
                    minlength: 2,
                    maxlength: 18
                },
                userZipCode: {
                    required: false,
                    minlength: 2,
                    maxlength: 191
                }
            },
            messages: {
                userName: {
                    required: "The user name is required",
                    minlength: "The user name must have at least 2 characters",
                    maxlength: "The user name cannot exceed 600 characters"
                },
                userEmail: {
                    required: "The user email is required",
                    email:  "The user email is invalid",
                    minlength: "The user email must have at least 2 characters",
                    maxlength: "The user email cannot exceed 191 characters"
                },
                userPhoneNumber: {
                    required: "The user phone is not required",
                    minlength: "The user phone must have at least 2 characters",
                    maxlength: "The user phone cannot exceed 18 characters"
                },
                userZipCode: {
                    required: "The user zip code is not required",
                    minlength: "The user zip code must have at least 2 characters",
                    maxlength: "The user zip code cannot exceed 191 characters"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_request_info_qr_set:function($params, $form, cback){
        $.ajax({
            url: "/degree/information/qr/requestInfo/"+$params.hash+"/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$.extend({},$params, $form),
            success: function ($data) {
                libs.expire($data);
                if(cback != undefined){
                    cback($data);
                }
            }
        });
    },
    //Admin
    information_request_edit:function($params, $data){
        var $credential = $data && $data.data && $data.data.user_credential ? $data.data.user_credential : [];
        $credential = $credential.map(function($x){return parseInt($x);});
        var $allowTabs = {
            'degree_information':  $.inArray(18, $credential) != -1 ? true : false,
            'degree_sponsor':  $.inArray(20, $credential) != -1  ? true : false
        };
        var $allowTabsFiltered = $allowTabs;
        $allowTabs = {};
        $.each($allowTabsFiltered, function($k, $v) {var $newObj = {};$newObj[$k]=$v;if($v){$.extend($allowTabs, $newObj);}});
        var $information = $("#nurseslounge-degree-information");
        var $informationRight = $information.find('.nurseslounge-degree-information-right:first .administrator:first');
        var $options = $informationRight.find('.option');
        $options.each(function(){
            var $that = $(this);
            var $action = $that.data('action');
            if(
                $action == 'create' ||
                $action == 'edit' ||
                $action == 'delete'
            ) {
                $that.unbind().click(function () {
                    var $tab = null;
                    $.each($allowTabs, function($i, $v){
                        if($v){
                            $tab = $i;
                            return false;
                        }
                    });
                    if(
                        $tab && $action == 'create' ||
                        $tab && $action == 'edit'
                    ){
                        nurseslounge_degree_information.information_request_select_tab($action, $tab, $allowTabs, $params, function () {
                            $("#nurseslounge-degree-information-edit-modal").scrollTop(0);
                            $("#nurseslounge-degree-information-edit-modal").modal('show');
                        });
                    }else
                    if($action == 'delete'){
                        if(confirm('Are you sure you want to delete this degree?')){
                            $params = $.extend({},$params, {action:$action,tab:$action});
                            nurseslounge_degree_information.information_apply_set($action, $params, function($data){
                                if($data.status == 'success'){
                                    router.navigate('/lounge/'+$data.data.key+'/degrees');
                                }
                            });
                        }
                    }
                });
            }
        });
    },
    information_request_select_tab:function($action, $tab, $allowTabs, $params, cback){
        nurseslounge_degree_information.information_request_tabs_events($action, $tab, $allowTabs, $params,function(){
            $params = $.extend({},$params, {user_id:libs.memoryGet('user_id'), tab:$tab, action:$action});
            nurseslounge_degree_information.information_request_load($tab, $params, function(){
                switch ($tab) {
                    case 'degree_information':
                        nurseslounge_degree_information.information_degree_get($params, function($data){
                            nurseslounge_degree_information.information_request_tab_information($action, $tab, $allowTabs, $params, $data, cback);
                        });
                    break;
                    case 'degree_sponsor':
                        nurseslounge_degree_information.information_degree_get($params, function($data){
                            nurseslounge_degree_information.information_request_tab_sponsor($action, $tab, $allowTabs, $params, $data, cback);
                        });
                    break;
                }
            });
        });
    },
    information_request_tabs_events:function($action, $tab, $allowTabs, $params, cback){
        //Disable All
        $('#nurseslounge-degree-information-edit-modal .nav-pills .nav-link').addClass('disabled').removeClass('active');
        $('#nurseslounge-degree-information-edit-modal .degree-information-modal-container .tab-pane .container').html('');
        //Events
        $('#nurseslounge-degree-information-edit-modal .nav-pills a[data-toggle="tab"]').unbind().on('shown.bs.tab', function ($e) {
            var $selectedTab = $e.currentTarget.dataset.target.replace('#','');
            if($.inArray($selectedTab, Object.keys($allowTabs)) > -1){
                nurseslounge_degree_information.information_request_select_tab($action, $selectedTab, $allowTabs, $params, function(){
                    $("#nurseslounge-job-information-edit-modal").scrollTop(0);
                });
            }
        });
        //Enable selected
        $.each($allowTabs, function ($i, $v) {
            $("#"+$v).removeClass('active').removeClass('show');
            $('#nurseslounge-degree-information-edit-modal .nav-pills .nav-link[data-target="#'+$i+'"]').removeClass('disabled');
        });
        $('#nurseslounge-degree-information-edit-modal .nav-pills .nav-link[data-target="#'+$tab+'"]').addClass('active');
        $("#"+$tab).addClass('active').addClass('show');
        if($action == 'create'){
            $("#nurseslounge-degree-information-edit-modal .modal-title").html('Create');
        }
        if($action == 'edit'){
            $("#nurseslounge-degree-information-edit-modal .modal-title").html('Edit');
        }
        if(cback != undefined){
            cback();
        }
    },
    information_request_load:function($tab, $params, cback){
        nurseslounge_degree_information.information_request_edit_view_get($tab, $params, function($chtml){
            var $images = $($chtml).find('img');
            libs.checkImageLoad($images, function(){
                $("#"+$tab+" .container").html($chtml).promise().done(function(){
                    if(cback != undefined){
                        cback();
                    }
                });
            });
        });
    },
    information_request_edit_view_get:function($tab, $params, cback){
        $params = $.extend({},$params,{user_id:libs.memoryGet('user_id'),tab:$tab});
        $.ajax({
            type: 'POST',
            url: '/degree/informationView/get',
            data: $params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_request_tab_information:function($action, $tab, $allowTabs, $params, $data, cback){
        var $degree = $data && $data.data && $data.data.degree ? $data.data.degree : null;
        var $degreeCategory = $data && $data.data && $data.data.degree_categories ? $data.data.degree_categories : null;
        var $degreeOffered = $data && $data.data && $data.data.degree_offered ? $data.data.degree_offered : null;
        var $degreeValidStates = $data && $data.data && $data.data.degree_valid_states ? $data.data.degree_valid_states : null;
        var $modal = $('#nurseslounge-degree-information-edit-modal');
        var $information = $modal.find('.degree-information-modal-container #degree_information .container');
        var $informationForm = $information.find('form:first');
        var $description = $informationForm.find('.description');
        var $selectAllStates = $informationForm.find('.select-all-states');
        var $unselectAllStates = $informationForm.find('.unselect-all-states');
        var $degreeCategoryOptions = '';
        $degreeCategoryOptions += '<option value="">Select the degree subcategory</option>';
        $.each($degreeCategory, function($i, $v){
            $degreeCategoryOptions += '<optgroup label="'+$v.category+'">';
            $.each($v.subcategory, function($sI, $sV){
                $degreeCategoryOptions += '<option value="'+$sV.id+'">'+$sV.subcategory+'</option>';
            });
            $degreeCategoryOptions += '</optgroup>';
        });
        var $degreeOfferedOptions = '';
        $degreeOfferedOptions += '<option value="">Select the degree offered</option>';
        var $degreeOfferedValue = '';
        $.each($degreeOffered, function($i, $v){
            switch($v){
                case 'Campus Only':
                    $degreeOfferedValue = 'Campus Only: This degree is only offered for on campus learning.';
                    break;
                case 'Online Only':
                    $degreeOfferedValue = 'Online Only: This degree program is 100% online.';
                    break;
                case 'Hybrid':
                    $degreeOfferedValue = 'Both: Students are required to attend a campus classroom at least once during the program. Does not include orientation.';
                    break;
            }
            $degreeOfferedOptions += '<option value="'+$i+'">'+$degreeOfferedValue+'</option>';
        });
        var $degreeValidStatesOptions = '';
        $.each($degreeValidStates, function($i, $v){
            $degreeValidStatesOptions += '<option value="'+$i+'">'+$v+'</option>';
        });
        $informationForm.find("select[name='degreeSubcategory']").html($degreeCategoryOptions);
        $informationForm.find("select[name='degreeOffered']").html($degreeOfferedOptions);
        $informationForm.find("select[name='degreeValidStates']").html($degreeValidStatesOptions).promise().done(function(){
            nurseslounge_degree_information.information_request_tab_information_validate(function($form){
                var $formObj = libs.getObjForm($form);
                var $formDescription = $description.summernote('code');
                var $newParams = $.extend({},$params, $formObj);
                $newParams = $.extend({},$newParams, {description:$formDescription,tab:$tab});
                nurseslounge_degree_information.information_apply_set($action, $newParams, function($data){
                    var $action = $data.data.action;
                    var $degreeKey = $data.data.degree_key;
                    $params = $.extend({},$params, {degree_key:$degreeKey,action:$action});
                    if($data.status == 'success'){
                        if($newParams.action == 'create'){
                            router.navigate($data.data.link,true);
                            nurseslounge_degree_information.init($params, function($data){
                                nurseslounge_degree_information.information_request_select_tab($action, $tab, $allowTabs, $params, cback);
                            });
                        }
                        if($newParams.action == 'edit'){
                            libs.refreshBoxFrom('.page-contents', $params, function(){
                                nurseslounge_degree_information.init($params, function($data){
                                    nurseslounge_degree_information.information_request_select_tab($action, $tab, $allowTabs, $params, cback);
                                });
                            });
                        }
                    }else{
                        $modal.modal('hide');
                    }
                });
            });
            try{
                $description.summernote('destroy');
            }catch (e) {

            }
            var $stripTags = function ($context) {
                var $ui = $.summernote.ui;
                var $button = $ui.button({
                    contents: 'Remove Formatting',
                    tooltip: 'Strip Tags',
                    click: function () {
                        var $text = [];
                        var $code = $description.summernote("code");
                        $($code).each(function(){
                            $text.push('<p>'+$(this).text()+'</p>');
                        });
                        $code = $text.join('');
                        $description.summernote("code", $code);
                    }
                });
                return $button.render();
            }
            $description.summernote({
                placeholder: 'Description ...',
                height: '400px',
                width: '100%',
                focus: true,
                disableResizeEditor: true,
                dialogsInBody: true,
                dialogsFade: true,
                codeviewFilter: true,
                codeviewIframeFilter: true,
                spellCheck: true,
                disableGrammar: false,
                styleTags: [
                    'p',
                    'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
                ],
                fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New'],
                fontSizeUnits: ['pt', 'px'],
                toolbar: [
                    ['style', ['style']],
                    ['font', ['fontname', 'fontsize', 'fontsizeunit']],
                    ['font', ['forecolor', 'backcolor']],
                    ['font', ['bold', 'italic', 'underline']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['para', ['height']],
                    ['stripTags', ['stripTags']]
                ],
                buttons: {
                    stripTags: $stripTags
                }
            });
            if($degree.title) {
                $informationForm.find("input[name='degreeTitle']").val($degree.title);
            }
            if($degree.subcategory_id) {
                $informationForm.find("select[name='degreeSubcategory']").val($degree.subcategory_id);
            }
            if($degree.offered_id) {
                $informationForm.find("select[name='degreeOffered']").val($degree.offered_id);
            }
            if($degree.cost_average) {
                $informationForm.find("input[name='degreeCostAverage']").val($degree.cost_average);
            }
            var $validStatesSelect = $informationForm.find("select[name='degreeValidStates']");
            try{
                $validStatesSelect.chosen('destroy');
            }catch (e) {}
            if($degree.valid_states){
                var $validStates = libs.pluck($degree.valid_states, 'state_id');
                $validStatesSelect.find('option').filter(function() {
                    return $.inArray(parseInt($(this).val()), $validStates) != -1;
                }).prop('selected',true);
            }
            $validStatesSelect.chosen();
            $selectAllStates.unbind().click(function(){
                $validStatesSelect.find('option').prop('selected', true);
                $validStatesSelect.trigger('chosen:updated');
            });
            $unselectAllStates.unbind().click(function(){
                $validStatesSelect.find('option').prop('selected', false);
                $validStatesSelect.trigger('chosen:updated');
            });
            if($degree.email) {
                $informationForm.find("input[name='degreeEmail']").val($degree.email);
            }
            if($degree.description) {
                $description.summernote('code', $degree.description);
            }
        });
        if(cback != undefined){
            cback();
        }
    },
    information_request_tab_information_validate:function(cback){
        var $validator;
        try {
            $validator = $("#degree_information form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#degree_information form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                degreeTitle: {
                    required: true,
                    minlength: 3,
                    maxlength: 191
                },
                degreeSubcategory: {
                    required: true
                },
                degreeOffered: {
                    required: true
                },
                degreeCostAverage: {
                    required: false,
                    minlength: 3,
                    maxlength: 191
                },
                degreeValidStates:{
                    required: true
                },
                degreeEmail: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                    email:true
                }
            },
            messages: {
                degreeTitle: {
                    required: "The degree title is required",
                    minlength: "The degree title must have at least 3 characters",
                    maxlength: "The degree title cannot exceed 191 characters"
                },
                degreeSubcategory: {
                    required: "The degree subcategory is required"
                },
                degreeValidStates: {
                    required: "The degree valid states is required"
                },
                degreeOffered: {
                    required: "The degree offered is required"
                },
                degreeCostAverage: {
                    required: "The degree cost average is not required",
                    minlength: "The degree cost average must have at least 3 characters",
                    maxlength: "The degree cost average cannot exceed 191 characters"
                },
                degreeEmail: {
                    required: "The degree email is required",
                    minlength: "The degree email must have at least 3 characters",
                    maxlength: "The degree email cannot exceed 191 characters",
                    email:"The degree email is invalid"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },

    information_request_tab_sponsor:function($action, $tab, $allowTabs, $params, $data, cback){
        var $degree = $data && $data.data && $data.data.degree ? $data.data.degree : null;
        var $modal = $('#nurseslounge-degree-information-edit-modal');
        var $sponsor = $modal.find('.degree-information-modal-container #degree_sponsor .container');
        var $sponsorForm = $sponsor.find('form:first');
        var $sponsorInput = $sponsorForm.find('input[name="sponsor"]');
        var $sponsorFromInput = $sponsorForm.find('input[name="sponsorFromDate"]');
        var $sponsorFromResetInput = $sponsorForm.find('.reset_from_date:first');
        var $sponsorToInput = $sponsorForm.find('input[name="sponsorToDate"]');
        var $sponsorToResetInput = $sponsorForm.find('.reset_to_date:first');
        $sponsorFromInput.datepicker().mask('00/00/0000',{placeholder:"mm/dd/yyyy"});
        $sponsorFromResetInput.unbind().click(function(){
            $sponsorFromInput.val("").datepicker("update");
        });
        $sponsorToInput.datepicker().mask('00/00/0000',{placeholder:"mm/dd/yyyy"});
        $sponsorToResetInput.unbind().click(function(){
            $sponsorToInput.val("").datepicker("update");
        });
        nurseslounge_degree_information.information_request_tab_sponsor_validate(function($form){
            var $formObj = libs.getObjForm($form);
            var $newParams = $.extend({},$params, $formObj);
            var $formSponsor = $sponsorInput.is(':checked');
            $newParams = $.extend({},$newParams, {sponsor:$formSponsor,tab:$tab});
            nurseslounge_degree_information.information_apply_set($action, $newParams, function($data){
                var $action = $data.data.action;
                var $degreeKey = $data.data.degree_key;
                $params = $.extend({},$params, {degree_key:$degreeKey,action:$action});
                if($data.status == 'success'){
                    nurseslounge_degree_information.init($params, function($data){
                        nurseslounge_degree_information.information_request_select_tab($action, $tab, $allowTabs, $params, cback);
                    });
                }else{
                    $modal.modal('hide');
                }
            });
        });
        if($degree.sponsored) {
            $sponsorInput.attr('checked', $degree.sponsored);
        }
        if($degree.date_from) {
            $sponsorFromInput.val($degree.date_from);
            $sponsorFromInput.datepicker("setDate", $degree.date_from);
        }
        if($degree.date_to) {
            $sponsorToInput.val($degree.date_to);
            $sponsorToInput.datepicker("setDate", $degree.date_to);
        }
        if(cback != undefined){
            cback();
        }
    },
    information_request_tab_sponsor_validate:function(cback){
        var $validator;
        try {
            $validator = $("#degree_sponsor form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#degree_sponsor form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                sponsor: {
                    required: false
                },
                sponsorFromDate: {
                    required: function(){
                        var $sponsor = $('#degree_sponsor');
                        return $sponsor.find('input[name="sponsor"]').is(':checked');
                    },
                    minlength: 10,
                    maxlength: 10,
                },
                sponsorToDate: {
                    required: function(){
                        var $sponsor = $('#degree_sponsor');
                        return $sponsor.find('input[name="sponsor"]').is(':checked');
                    },
                    minlength: 10,
                    maxlength: 10,
                }
            },
            messages: {
                sponsor: {
                    required: "The sponsor is not required",
                },
                sponsorFromDate: {
                    required: "The sponsor from date is required",
                    minlength: "The sponsor from date is not a correct date",
                    maxlength: "The sponsor from date is not a correct date"
                },
                sponsorToDate: {
                    required: "The sponsor to date is required",
                    minlength: "The sponsor to date is not a correct date",
                    maxlength: "The sponsor to date is not a correct date"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    //Review
    information_review:function($params, $data, executed){
        var $reviewModal = $("#nurseslounge-degree-information-review-modal");
        var $contentDiv = $reviewModal.find('.content:first');
        nurseslounge_degree_information.information_review_form($params, 'msg',function($chtml){
            $contentDiv.html($chtml).promise().done(function(){
                var $agreeCheckbox = $reviewModal.find('input[name="agree"]');
                var $startBtn = $reviewModal.find('.start-btn');
                $agreeCheckbox.unbind().click(function(){
                    if($agreeCheckbox.is(':checked')){
                        nurseslounge_degree_information.information_review_count_down(function(){
                            nurseslounge_degree_information.information_review_form($params, 'degree',function($chtml){
                                $contentDiv.html($chtml).promise().done(function(){
                                    nurseslounge_degree_information.information_review_degree_events($params, $data, null, executed);
                                });
                            });
                        });
                    }else{
                        $startBtn.prop('disabled', true);
                    }
                });
                $reviewModal.modal('show');
            });
        });
    },
    information_remove_review:function($params, cback){
        $.ajax({
            url: "/degree/reviews/delete",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-degree-information-edit-modal").modal('hide');
                    $("#nurseslounge-degree-information-review-modal").modal('hide');
                    $("#nurseslounge-degree-request-info-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    information_review_count_down:function(cback){
        var $reviewModal = $("#nurseslounge-degree-information-review-modal");
        var $startBtn = $reviewModal.find('.start-btn');
        $startBtn.prop('disabled', false);
        $startBtn.unbind().click(function(){
            cback();
        });
    },
    information_review_form:function($params, $part, cback){
        $params = $.extend({},$params, {part:$part});
        $.ajax({
            type: 'POST',
            url: '/degree/informationReviewView/get',
            data:$params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-degree-information-edit-modal").modal('hide');
                    $("#nurseslounge-degree-information-review-modal").modal('hide');
                    $("#nurseslounge-degree-request-info-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    information_review_degree_events:function($params, $data, cback, executed){
        if(!libs.memoryGet('degree-review')){
            libs.memorySave('degree-review', $params);
        }
        var $degree = $data.data.degree;
        var $myReview = $degree.my_review;
        var $reviewModal = $("#nurseslounge-degree-information-review-modal");
        var $ratingStars = $reviewModal.find('.rating-stars:first');
        var $ratingCount = $reviewModal.find('.rating-count:first');
        var $overallInput = $reviewModal.find('input[name="overallRating"]');
        var $form = $reviewModal.find(".step1 form:first");
        $form.unbind();
        $reviewModal.find('.step1').hide();
        $reviewModal.find('.step2').hide();
        $reviewModal.find('.current').hide();
        $reviewModal.find('.former').hide();
        $reviewModal.find('.step3').hide();
        //Fill
        var $degreeReview = libs.memoryGet('degree-review');
        var $overallRatingVal = $degreeReview.overallRating ? $degreeReview.overallRating : $myReview && $myReview.overall_rating ? $myReview.overall_rating : 0;
        var $recommendToFriendVal = $degreeReview.recommendToFriend ? $degreeReview.recommendToFriend : $myReview && $myReview.recommend_to_friend && $myReview.recommend_to_friend;
        var $studentTypeVal = $degreeReview.studentType ? $degreeReview.studentType : $myReview && $myReview.student_type ? $myReview.student_type : '';
        if($recommendToFriendVal != ''){
            $reviewModal.find('input[name="recommendToFriend"][value='+$recommendToFriendVal+']').attr('checked', 'checked');
        }
        if($studentTypeVal != ''){
            $reviewModal.find('input[name="studentType"][value='+$studentTypeVal+']').attr('checked', 'checked');
        }
        $ratingStars.html(nurseslounge_degree_information.add_stars($overallRatingVal));
        $ratingCount.html('<p>'+$overallRatingVal+' / 5 Star</p>');
        $overallInput.val($overallRatingVal);
        //Events
        nurseslounge_degree_information.information_review_degree_events_validate_step1(function($form){
            libs.memoryUpdateObj('degree-review', libs.getObjForm($form));
            nurseslounge_degree_information.information_review_degree_step2($params, $data, cback, executed);
        });
        var $ratingStarsSvg = $ratingStars.find('svg');
        $ratingStarsSvg.unbind().click(function($event){
            var $that = $(this);
            var $left = $event.clientX - $that.offset().left;
            var $width = $that.width();
            var $leftColor = ($left * 100) / $width;
            var $rightColor = 100 - $leftColor;
            var $url = $that.attr('fill');
            $url = $url.replace('url(#','').replace(')','');
            var $percentReviewId = $url.replace('percentReview','');
            var $totalPercent = 500;
            var $actualPercent = 0;
            for(var $x=1;$x<=5;$x++){
                var $chtml = '';
                var $leftPercent;
                var $rightPercent;
                if($x == $percentReviewId){
                    //$leftPercent = $leftColor < 15 ? 0 : $leftColor > 85 ? 100 : $leftColor;
                    $leftPercent = $leftColor < 15 ? 0 : 100;
                    $rightPercent = $rightColor;
                    $actualPercent+= $leftPercent;
                }
                if($x < $percentReviewId){
                    $leftPercent = 100;
                    $rightPercent = 0;
                    //$actualPercent+= $leftPercent;
                    $actualPercent+= 100;
                }
                if($x > $percentReviewId){
                    $leftPercent = 0;
                    $rightPercent = 100;
                    //$actualPercent+= $leftPercent;
                    $actualPercent+= 0;
                }
                if($leftPercent > 10) {
                    $chtml += '' +
                        '<stop offset="' + $leftPercent + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
                }
                if($rightPercent > 10) {
                    $chtml += '' +
                        '<stop offset="' + $rightPercent + '%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
                }
                $("#percentReview"+$x).html($chtml);
            }
            var $selectedPercent = ($actualPercent/$totalPercent) * 5;
            $selectedPercent = Math.ceil($selectedPercent * 10) / 10;
            $selectedPercent > 0 ? $selectedPercent.toFixed(1) : 0;
            $ratingCount.html('<p>'+$selectedPercent+' / 5 Star</p>');
            $overallInput.val($selectedPercent);
            $form.find('.invalid-feedback').hide();
            $form.find('.error').removeClass('error');
            $form.find('.is-invalid').removeClass('is-invalid');
        });
        $reviewModal.find('.step1').show();
        $reviewModal.find('.step2').hide();
        $reviewModal.find('.step3').hide();
        if(cback != undefined){
            cback();
        }
    },
    add_stars:function($rating){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++) {
            var $star = $rating - $i;
            var $offsetOn;
            var $offsetOff;
            if($star >= 0){
                $offsetOn = 100;
                $offsetOff = 0;
            }else if($star < 0 && $star > -1){
                $star = ($star * -1);
                $offsetOff = ($star * 100);
                $offsetOn = (100 - $offsetOff);
            }else{
                $offsetOn = 0;
                $offsetOff = 100;
            }
            $chtml += '' +
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="url(#percentReview'+$i+')">' +
                '   <defs>' +
                '       <linearGradient id="percentReview'+$i+'">';
            if($offsetOn > 0) {
                $chtml += '' +
                    '<stop offset="' + $offsetOn + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
            }
            if($offsetOff > 0){
                $chtml += '' +
                    '<stop offset="'+$offsetOff+'%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
            }
            $chtml += '' +
                '       </linearGradient>' +
                '   </defs>' +
                '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566"></polygon>' +
                '</svg>';
        }
        return $chtml;
    },
    information_review_degree_events_validate_step1:function(cback){
        $.validator.addMethod("greaterThanZero", function($val) {
            return parseFloat($val) > 0;
        },'Must be greater than zero.');
        var $validator;
        try {
            $validator = $("#nurseslounge-degree-information-review-modal .step1 form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-degree-information-review-modal .step1 form").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                overallRating: {
                    required: true,
                    greaterThanZero: true
                },
                recommendToFriend: {
                    required: true
                },
                studentType: {
                    required: true
                }
            },
            messages: {
                overallRating: {
                    required: "The overall rating is required",
                    greaterThanZero: "The overall rating must be greater than 0",
                },
                recommendToFriend: {
                    required: "The recommend to a friend is required"
                },
                studentType: {
                    required: "The student type is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_review_degree_step2:function($params, $data, cback, executed){
        var $degree = $data.data.degree;
        var $myReview = $degree.my_review;
        var $reviewModal = $("#nurseslounge-degree-information-review-modal");
        var $expectedGraduationDateSelect = $reviewModal.find('select[name="expectedGraduationDate"]');
        var $degreeProgramCurrentSelect = $reviewModal.find('select[name="degreeProgramCurrent"]');
        var $otherProgramCurrentInput = $reviewModal.find('input[name="otherProgramCurrent"]');
        var $yearGraduatedSelect = $reviewModal.find('select[name="yearGraduated"]');
        var $degreeProgramFormerSelect = $reviewModal.find('select[name="degreeProgramFormer"]');
        var $otherProgramFormerInput = $reviewModal.find('input[name="otherProgramFormer"]');
        var $otherDegreeCurrent = $reviewModal.find('.other-degree-current');
        var $otherDegreeFormer = $reviewModal.find('.other-degree-former');
        var $back = $reviewModal.find('.back');
        var $form = $reviewModal.find(".step2 form:first");
        $form.unbind();
        $reviewModal.find('.step1').hide();
        $reviewModal.find('.step2').hide();
        $reviewModal.find('.current').hide();
        $reviewModal.find('.former').hide();
        $reviewModal.find('.step3').hide();
        var $review = libs.memoryGet('degree-review');
        var $studentTypeOption = $review.studentType;
        switch ($studentTypeOption) {
            case 'current':
                $reviewModal.find('.current').show();
                nurseslounge_degree_information.information_review_degree_events_validate_step2_current(function($form){
                    libs.memoryUpdateObj('degree-review', libs.getObjForm($form));
                    nurseslounge_degree_information.information_review_school_step3($params, $data, cback, executed);
                });
                var $expectedGraduationDateVal = $review && $review.expectedGraduationDate ? $review.expectedGraduationDate : $myReview && $myReview.expected_graduation_date ? $myReview.expected_graduation_date : '';
                $expectedGraduationDateSelect.val($expectedGraduationDateVal);
                var $degreeProgramCurrentVal = $review && $review.degreeProgramCurrent ? $review.degreeProgramCurrent : $myReview && $myReview.degree_program ? $myReview.degree_program : $degree && $degree.title ? $degree.title : '';
                $degreeProgramCurrentSelect.val($degreeProgramCurrentVal);
                if($degreeProgramCurrentVal == 'other'){
                    $otherDegreeCurrent.show();
                }else{
                    $otherDegreeCurrent.hide();
                }
                var $otherProgramCurrentVal = $review && $review.otherProgramCurrent ? $review.otherProgramCurrent : $myReview && $myReview.other_program ? $myReview.other_program : '';
                $otherProgramCurrentInput.val($otherProgramCurrentVal);
                break;
            case 'former':
                $reviewModal.find('.former').show();
                nurseslounge_degree_information.information_review_degree_events_validate_step2_former(function($form){
                    libs.memoryUpdateObj('degree-review', libs.getObjForm($form));
                    nurseslounge_degree_information.information_review_school_step3($params, $data, cback, executed);
                });
                var $yearGraduatedSelectVal = $review && $review.yearGraduated ? $review.yearGraduated : $myReview && $myReview.year_graduated ? $myReview.year_graduated : '';
                $yearGraduatedSelect.val($yearGraduatedSelectVal);
                var $degreeProgramFormerVal = $review && $review.degreeProgramFormer ? $review.degreeProgramFormer : $myReview && $myReview.degree_program ? $myReview.degree_program : $degree && $degree.title ? $degree.title : '';
                $degreeProgramFormerSelect.val($degreeProgramFormerVal);
                if($degreeProgramFormerVal == 'other'){
                    $otherDegreeFormer.show();
                }else{
                    $otherDegreeFormer.hide();
                }
                var $otherDegreeFormerVal = $review && $review.otherProgramFormer ? $review.otherProgramFormer : $myReview && $myReview.other_program ? $myReview.other_program : '';
                $otherProgramFormerInput.val($otherDegreeFormerVal);
                break;
        }
        $back.unbind().click(function(){
            nurseslounge_degree_information.information_review_degree_events($params, $data, cback, executed);
        });
        $degreeProgramCurrentSelect.unbind().change(function(){
            if($(this).val() == 'other'){
                $otherDegreeCurrent.show();
            }else{
                $otherDegreeCurrent.hide();
            }
        });
        $degreeProgramFormerSelect.unbind().change(function(){
            if($(this).val() == 'other'){
                $otherDegreeFormer.show();
            }else{
                $otherDegreeFormer.hide();
            }
        });
        $reviewModal.find('.step1').hide();
        $reviewModal.find('.step2').show();
        $reviewModal.find('.step3').hide();
    },
    information_review_degree_events_validate_step2_current:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-degree-information-review-modal .step2 form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-degree-information-review-modal .step2 form").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                expectedGraduationDate:{
                    required: true
                },
                degreeProgramCurrent:{
                    required: true
                },
                otherProgramCurrent:{
                    required: function(){
                        return $("#nurseslounge-degree-information-review-modal .step2").find('select[name="degreeProgramCurrent"]').val() == 'other';
                    },
                    minlength: 1,
                    maxlength: 600
                }
            },
            messages: {
                expectedGraduationDate:{
                    required: "The expected graduation is required"
                },
                degreeProgramCurrent:{
                    required: "The degree program is required"
                },
                otherProgramCurrent: {
                    required: "The other degree program is required",
                    minlength: "The other degree program is must have at least 1 characters",
                    maxlength: "The other degree program is cannot exceed 600 characters"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_review_degree_events_validate_step2_former:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-degree-information-review-modal .step2 form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-degree-information-review-modal .step2 form").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                yearGraduated:{
                    required: true
                },
                degreeProgramFormer:{
                    required: true
                },
                otherProgramFormer:{
                    required: function(){
                        return $("#nurseslounge-degree-information-review-modal .step2").find('select[name="degreeProgramFormer"]').val() == 'other';
                    },
                    minlength: 1,
                    maxlength: 600
                }
            },
            messages: {
                yearGraduated:{
                    required: "The year of graduation is required"
                },
                degreeProgramFormer:{
                    required: "The degree program is required"
                },
                otherProgramFormer: {
                    required: "The other degree program is required",
                    minlength: "The other degree program is must have at least 1 characters",
                    maxlength: "The other degree program is cannot exceed 600 characters"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_review_school_step3:function($params, $data, cback, executed){
        var $degree = $data.data.degree;
        var $myReview = $degree.my_review;
        var $reviewModal = $("#nurseslounge-degree-information-review-modal");
        var $locationSelect = $reviewModal.find('select[name="location"]');
        var $degreeHeadlineInput = $reviewModal.find('input[name="degreeHeadline"]');
        var $prosText = $reviewModal.find('textarea[name="pros"]');
        var $consText = $reviewModal.find('textarea[name="cons"]');
        var $form = $reviewModal.find(".step3 form:first");
        $form.unbind();
        $reviewModal.find('.step1').hide();
        $reviewModal.find('.step2').hide();
        $reviewModal.find('.current').hide();
        $reviewModal.find('.former').hide();
        $reviewModal.find('.step3').hide();
        var $review = libs.memoryGet('degree-review');
        var $back = $reviewModal.find('.back');
        nurseslounge_degree_information.information_review_degree_events_validate_step3(function($form){
            libs.memoryUpdateObj('degree-review', libs.getObjForm($form));
            nurseslounge_degree_information.information_form_request(function($data){
                executed();
            });
        });
        $back.unbind().click(function(){
            nurseslounge_degree_information.information_review_degree_step2($params, $data, cback, executed);
        });
        var $locationSelectVal = $review && $review.location ? $review.location : $myReview && $myReview.location ? $myReview.location : '';
        $locationSelect.val($locationSelectVal);
        var $degreeHeadlineVal = $review && $review.degreeHeadline ? $review.degreeHeadline : $myReview && $myReview.degree_headline ? $myReview.degree_headline : '';
        $degreeHeadlineInput.val($degreeHeadlineVal);
        var $prosVal = $review && $review.pros ? $review.pros : $myReview && $myReview.pros ? $myReview.pros : '';
        $prosText.val($prosVal);
        var $consVal = $review && $review.cons ? $review.cons : $myReview && $myReview.cons ? $myReview.cons : '';
        $consText.val($consVal);
        $reviewModal.find('.step1').hide();
        $reviewModal.find('.step2').hide();
        $reviewModal.find('.current').hide();
        $reviewModal.find('.former').hide();
        $reviewModal.find('.step3').show();
    },
    information_review_degree_events_validate_step3:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-degree-information-review-modal .step3 form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-degree-information-review-modal .step3 form").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                location:{
                    required: true
                },
                degreeHeadline:{
                    required: true,
                    minlength: 3,
                    maxlength: 191
                },
                pros:{
                    required: true,
                    minlength: 3,
                    maxlength: 600
                },
                cons:{
                    required: false,
                    minlength: 3,
                    maxlength: 600
                }
            },
            messages: {
                location:{
                    required: "The location is required"
                },
                degreeHeadline:{
                    required: "The degree headline is required",
                    minlength: "The degree headline must have at least 3 characters",
                    maxlength: "The degree headline cannot exceed 191 characters"
                },
                pros:{
                    required: "The pros is required",
                    minlength: "The pros must have at least 3 characters",
                    maxlength: "The pros cannot exceed 600 characters"
                },
                cons:{
                    required: "The suggestion is not required",
                    minlength: "The suggestion must have at least 3 characters",
                    maxlength: "The suggestion cannot exceed 600 characters"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_form_request:function(cback){
        $.ajax({
            url: "/degree/reviews/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:libs.memoryGet('degree-review'),
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-degree-information-edit-modal").modal('hide');
                    $("#nurseslounge-degree-information-review-modal").modal('hide');
                    $("#nurseslounge-degree-request-info-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    //Meet our recruiters
    information_meet_our_recruiters:function(cback){
        cback({
            'container':$("#nurseslounge-degree-information .nurseslounge-degree-information-right .meet-our-recruiters")
        });
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-degree-information .nurseslounge-degree-information-right .banners")
        });
    },
};
